import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-row" }
const _hoisted_2 = { class: "languages" }
const _hoisted_3 = { class: "user-items" }
const _hoisted_4 = { class: "centred" }
const _hoisted_5 = { class: "centred" }
const _hoisted_6 = { class: "centred" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LanguageSwitch = _resolveComponent("LanguageSwitch")!
  const _component_UserGreeting = _resolveComponent("UserGreeting")!
  const _component_ShortcutsInfo = _resolveComponent("ShortcutsInfo")!
  const _component_LogOut = _resolveComponent("LogOut")!
  const _component_NewUserPrompt = _resolveComponent("NewUserPrompt")!
  const _component_NewDesignPrompt = _resolveComponent("NewDesignPrompt")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LanguageSwitch)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UserGreeting)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ShortcutsInfo)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_LogOut)
        ])
      ])
    ]),
    _createVNode(_component_NewUserPrompt),
    _createVNode(_component_NewDesignPrompt)
  ], 64))
}